import { useSelector } from "react-redux";
import store from "../../storeWire";
import {
    setFilterList,
    clearFilterByKey,
    clearAllFilter,
    clearArryVal
} from "../../store/slice/model/Admin/AdminFilter";

export function useAdminFilterStore() {
    const filter_list = useSelector((state) => state.entities.model_admin_filter.filterList)

    let data = {
        filter_list
    };
    let fetch = {
    };
    let set = {
        set_filter_list: async (params) => {
            return await store.dispatch(setFilterList(params))
        },
        clear_filter_by_key: async (params) => {
            return await store.dispatch(clearFilterByKey(params))
        },
        clear_all_filter: async () => {
            return await store.dispatch(clearAllFilter())
        },
        clear_arry_value: async (params) => {
            return await store.dispatch(clearArryVal(params))
        },
    };
    return [data, fetch, set]
}